// extracted by mini-css-extract-plugin
module.exports = {"loaderRoot":"styles_loaderRoot__3v2Jm"};